import React, { useEffect, useRef, useState, useContext } from 'react'
import ReactDOM from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentInner } from '../../../../../layout/Content'
import ModalWindow from '../../../../../layout/modalwindow/ModalWindow'
import SwitchButton from '../../../../../layout/switch_button/SwitchButton'
import CloseButton from '../../../../../layout/close_button/CloseButton'
import DivButton from '../../../../../layout/divbutton/DivButton'
import UsersAccountsStyle from './css/UsersAccountsStyle'
import { usersAccountsControllerContext } from './UsersAccountsController'

function UsersAccounts() {
  const usersAccountsController = useContext(usersAccountsControllerContext)
  const { updateClientUser, users, resetUser } = usersAccountsController
  const [user, setUser] = usersAccountsController.user
  const [newUserPassword, setNewUserPassword] = useState({ password: '', confirm_password: '' })
  // const [error, setError] = useState({ group: '', id: '', message: '' })
  const [error, setError] = useState(null)
  const firstNameRef = useRef(null)
  const [addNew, setAddNew] = useState(false)
  const [edit, setEdit] = useState(false)
  const [changePassword, setChangePassword] = useState(false)
  const initElement = {
    // Top containers
    users_personal_info: { expand: true },
    login_details: { expand: true },
    users_modules_access: { expand: false },

    // Module names
    dashboard: { expand: false, on: false },

    /* Products ***********************/
    products: { expand: false, on: false },
    products_fc: { on: false },

    /* Stockin ***********************/
    stockin: { expand: false, on: false },
    stockin_fc: { on: false },

    /* Stockout ***********************/
    stockout: { expand: false, on: false },
    stockout_fc: { on: false },

    /* Invoice ***********************/
    invoice: { expand: false, on: false },
    invoice_fc: { on: false },

    /* Customers Account ***********************/
    customers_accounts: { expand: false, on: false },
    customers_accounts_fc: { on: false },

    /* Receipts ***********************/
    receipts: { expand: false, on: false },
    receipts_fc: { on: false },

    /* Reports ***********************/
    reports: { expand: false, on: false },
    // Sales Reports
    reports_sales_reports: { expand: false, on: false },
    reports_sales_reports_daily_sales: { on: false },
    reports_sales_reports_monthly_sales: { on: false },
    reports_sales_reports_yearly_sales: { on: false },
    reports_sales_reports_receivables: { on: false },
    // Inventory Reports
    reports_inventory_reports: { expand: false, on: false },
    reports_inventory_reports_products_inventory: { on: false },
    reports_inventory_reports_out_of_stocks: { on: false },
    reports_inventory_reports_price_list: { on: false },
    reports_inventory_reports_products_sold: { on: false },
    reports_inventory_reports_unmoving_products: { on: false },
    reports_inventory_reports_products_with_expirations: { on: false },

    /* Utilities ***********************/
    utilities: { expand: false, on: false },
    utilities_purchase_order: { on: false },
    utilities_percent_off_batch_set: { on: false },
    utilities_reset_percent_off: { on: false },

    /* Settings ***********************/
    settings: { expand: false, on: false },
    settings_warehouses: { on: false },
    settings_vat: { on: false },
    settings_npos_accounts_settings: { on: false },
    help: { expand: false, on: false }
  }
  const [element, setElement] = useState(initElement)

  const setSwitch = (id, key) => {
    setElement({ ...element, [id]: { ...element[id], on: key } })
    setUser({ ...user, user_access: { ...user.user_access, [id]: key } })
  }

  const onClickWrapperHeader = (e) => {
    const control_wrapper = e.target.closest('.control-wrapper')
    const field_container = control_wrapper.querySelector('.fields-container')

    const isSwitchButton = e.target.closest('.switch-button-container')

    if (isSwitchButton) {
      // Disable switch buttons for the current selected module
      if (field_container) {
        const button_id = e.target.closest('.control-header-title').id
        if (element[button_id].on) {
          // Check to see if id is reports
          if (button_id === 'reports') {
            ['reports_sales_reports', 'reports_inventory_reports'].forEach(rep => {
              const ht_button = document.getElementById(rep)
              const switch_buttons_wrapper = ht_button.querySelector('.switch-button-wrapper')
              switch_buttons_wrapper.classList.add('disabled-sb')

              const switch_buttons = switch_buttons_wrapper.querySelectorAll('.circle-button')
              switch_buttons.forEach((sb, i) => { sb.setAttribute('disabled', 'true') })

              if (element[rep].on) {
                const cw = document.getElementById(rep+'-cw')
                const fc = cw.querySelector('.fields-container')

                const switch_buttons_wrapper = fc.querySelectorAll('.switch-button-wrapper')
                switch_buttons_wrapper.forEach((sb, i) => { sb.classList.add('disabled-sb') })

                const switch_buttons = fc.querySelectorAll('.circle-button')
                switch_buttons.forEach((sb, i) => { sb.setAttribute('disabled', 'true') })
              }
            })
          } else {
            // disable switch buttons
            const switch_buttons_wrapper = field_container.querySelectorAll('.switch-button-wrapper')
            switch_buttons_wrapper.forEach((sb, i) => { sb.classList.add('disabled-sb') })

            const switch_buttons = field_container.querySelectorAll('.circle-button')
            switch_buttons.forEach((sb, i) => { sb.setAttribute('disabled', 'true') })
          }
        } else {
          // Check to see if id is reports
          if (button_id === 'reports') {
            ['reports_sales_reports', 'reports_inventory_reports'].forEach(rep => {
              const ht_button = document.getElementById(rep)
              const switch_buttons_wrapper = ht_button.querySelector('.switch-button-wrapper')
              switch_buttons_wrapper.classList.remove('disabled-sb')

              const switch_buttons = switch_buttons_wrapper.querySelectorAll('.circle-button')
              switch_buttons.forEach((sb, i) => { sb.removeAttribute('disabled') })

              if (element[rep].on) {
                const cw = document.getElementById(rep+'-cw')
                const fc = cw.querySelector('.fields-container')

                const switch_buttons_wrapper = fc.querySelectorAll('.switch-button-wrapper')
                switch_buttons_wrapper.forEach((sb, i) => { sb.classList.remove('disabled-sb') })

                const switch_buttons = fc.querySelectorAll('.circle-button')
                switch_buttons.forEach((sb, i) => { sb.removeAttribute('disabled') })
              }
            })
          } else {
            // enable switch buttons
            const switch_buttons_wrapper = field_container.querySelectorAll('.switch-button-wrapper')
            switch_buttons_wrapper.forEach((sb, i) => { sb.classList.remove('disabled-sb') })

            const switch_buttons = field_container.querySelectorAll('.circle-button')
            switch_buttons.forEach((sb, i) => { sb.removeAttribute('disabled') })
          }
        }
      }

      return
    }

    // Hide/show the field container if control-header-title was clicked
    if (field_container) field_container.classList.toggle('hide-fc')
    const ht = e.target.closest('.control-header-title')
    setElement({ ...element, [ht.id]: { ...element[ht.id], expand: !element[ht.id].expand} })
  }

  const onClickChangePassword = (e) => { setChangePassword(true) }

  /*** Control's Enabler functions *********/
  // Left wrapper
  const enableLeftWrapper = () => {
    // Enable left wrapper input_s
    const left_wrapper_input = document.querySelector('.left-wrapper').querySelectorAll('input')
    left_wrapper_input.forEach((input, i) => {
      input.removeAttribute('readonly')
      input.classList.remove('read-only')
    })

    for (let el in element) {
      // Enable the header title button only not the children
      const ht_button = document.getElementById(el)
      if (ht_button) {
        if (['reports_sales_reports', 'reports_inventory_reports'].includes(el)) {
          // check the parent container
          if (element.reports.on) {
            //const cw = document.getElementById(el+'-cw')
            const switch_buttons_wrapper = ht_button.querySelectorAll('.switch-button-wrapper')
            switch_buttons_wrapper.forEach((sb, i) => { sb.classList.remove('disabled-sb') })

            const switch_buttons = ht_button.querySelectorAll('.circle-button')
            switch_buttons.forEach((sb, i) => { sb.removeAttribute('disabled') })
          }

          // The field container part
          if (element[el].on) {
            const cw = document.getElementById(el+'-cw')
            const fc = cw.querySelector('.fields-container')

            const switch_buttons_wrapper = fc.querySelectorAll('.switch-button-wrapper')
            switch_buttons_wrapper.forEach((sb, i) => { sb.classList.remove('disabled-sb') })

            const switch_buttons = fc.querySelectorAll('.circle-button')
            switch_buttons.forEach((sb, i) => { sb.removeAttribute('disabled') })
          }
        } else {
          // Enable parent first (current element)
          const switch_buttons_wrapper = ht_button.querySelector('.switch-button-wrapper')
          if (switch_buttons_wrapper) switch_buttons_wrapper.classList.remove('disabled-sb')

          if (switch_buttons_wrapper) {
            const switch_buttons = switch_buttons_wrapper.querySelectorAll('.circle-button')
            switch_buttons.forEach((sb, i) => { sb.removeAttribute('disabled') })
          }

          // The field container part (child)
          if (element[el].on && el !== 'reports') {
            const cw = document.getElementById(el+'-cw')
            const fc = cw.querySelector('.fields-container')

            if (fc) {
              const switch_buttons_wrapper = fc.querySelectorAll('.switch-button-wrapper')
              switch_buttons_wrapper.forEach((sb, i) => { sb.classList.remove('disabled-sb') })

              const switch_buttons = fc.querySelectorAll('.circle-button')
              switch_buttons.forEach((sb, i) => { sb.removeAttribute('disabled') })
            }
          }
        }
      }
    }
  }

  /*** Control's Disabler Functions ***********/
  // Left wrapper
  const disableLeftWrapper = () => {
    // Disable left wrapper inputs
    const left_wrapper_input = document.querySelector('.left-wrapper').querySelectorAll('input')
    left_wrapper_input.forEach((input, i) => {
      input.setAttribute('readonly', 'true')
      input.classList.add('read-only')
    })

    // Disable switch buttons
    const switch_buttons_wrapper = document.querySelectorAll('.switch-button-wrapper')
    switch_buttons_wrapper.forEach((sb, i) => { sb.classList.add('disabled-sb') })

    const switch_buttons = document.querySelectorAll('.circle-button')
    switch_buttons.forEach((sb, i) => { sb.setAttribute('disabled', 'true') })
  }

  // Right wrapper
  const disableRightWrapper = () => {
    /*** Disable right wrapper contents ***********/
    // Disable table
    const right_wrapper_users_table = document.querySelector('.right-wrapper').querySelector('table')
    right_wrapper_users_table.classList.add('disabled')

    // Disable buttons
    const right_wrapper_cb = document.querySelector('.right-wrapper').querySelectorAll('.close-button')
    right_wrapper_cb.forEach((cb, i) => { cb.setAttribute('disabled', 'true') })
  }

  // Right wrapper
  const enableRightWrapper = () => {
    // Enable table
    const right_wrapper_users_table = document.querySelector('.right-wrapper').querySelector('table')
    right_wrapper_users_table.classList.remove('disabled')

    // Enable right wrapper contents
    const right_wrapper_cb = document.querySelector('.right-wrapper').querySelectorAll('.close-button')
    right_wrapper_cb.forEach((cb, i) => { cb.removeAttribute('disabled') })
  }

  const onChangeUserPersonalInfo = (e) => { setUser({ ...user, [e.target.id]: e.target.value }) }
  const onChangeUserLoginDetails = (e) => {
    setUser({ ...user, login_details: { ...user.login_details, [e.target.id]: e.target.value } })
  }

  const onClickAddNew = (e) => {
    setAddNew(true)
    resetUser()
    setElement(initElement)
    clearTableRowFocus()
    enableLeftWrapper()
    disableRightWrapper()
    firstNameRef.current.focus()
  }

  const onClickCancel = (e) => {
    setAddNew(false)
    setEdit(false)
    setChangePassword(false)
    setError(null)
    disableLeftWrapper()
    enableRightWrapper()

    const selected_user = users.find(u => u.id === parseInt(user.id))
    if (selected_user) {
      setUser(selected_user)
      setNewUserPassword({password: '', confirm_password: ''})
    } else { resetUser() }
  }

  const onClickEdit = (e) => {
    setEdit(true)
    enableLeftWrapper()
    disableRightWrapper()
    firstNameRef.current.focus()
  }

  const showDeleteUserAccountMessageBox = (user_id) => {
    const onClick = async (button) => {
      if (button === 'Yes') {
        await updateClientUser('delete', user_id)
        clearTableRowFocus()
      }

      ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
    }

    ReactDOM.render(
      <ModalWindow
        id='mw-parent'
        header="Delete User Account"
        footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content' style={{fontSize: '1.2rem'}}>
              <p>{`You are to delete the record with ID: ${user_id}`}</p>
              <br />
              <p>Are you sure you want to continue?</p>
              <br />
            </div>
            <div className='button-container'>
              <button onClick={() => { onClick('No') }} className='pospro-action-btn top-anchor'>No</button>
              <button onClick={() => { onClick('Yes') }} className='pospro-action-btn bottom-anchor'>Yes</button>
            </div>
          </div>
        </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickDeleteUserAccount = async (e) => {
    const userSelected = e.target.closest('.user-row')
    showDeleteUserAccountMessageBox(userSelected.id)
  }

  const clearTableRowFocus = () => {
    const table = document.querySelector('.table')
    const rows = table.querySelectorAll('.user-row')
    rows.forEach((row, i) => { row.classList.remove('focus') })
  }

  const onClickUser = (e) => {
    const close_button = e.target.closest('.close-button')
    if (close_button) { return }

    clearTableRowFocus()

    const userSelected = e.target.closest('.user-row')
    userSelected.classList.add('focus')

    const selected_user = users.find(user => user.id === parseInt(userSelected.id))

    setElement({
      ...element,
      dashboard: { ...element.dashboard, on: selected_user.user_access.dashboard },
      products: { ...element.products, on: selected_user.user_access.products },
      products_fc: { on: selected_user.user_access.products_fc },
      stockin: { ...element.stockin, on: selected_user.user_access.stockin },
      stockin_fc: { on: selected_user.user_access.stockin_fc },
      stockout: { ...element.stockout, on: selected_user.user_access.stockout },
      stockout_fc: { on: selected_user.user_access.stockout_fc },
      invoice: { ...element.invoice, on: selected_user.user_access.invoice },
      invoice_fc: { on: selected_user.user_access.invoice_fc },
      customers_accounts: { ...element.customers_accounts, on: selected_user.user_access.customers_accounts },
      customers_accounts_fc: { on: selected_user.user_access.customers_accounts_fc },
      receipts: { ...element.receipts, on: selected_user.user_access.receipts },
      receipts_fc: { on: selected_user.user_access.receipts_fc },
      reports: { ...element.reports, on: selected_user.user_access.reports },
      reports_sales_reports: { ...element.reports_sales_reports, on: selected_user.user_access.reports_sales_reports },
      reports_sales_reports_daily_sales: { on: selected_user.user_access.reports_sales_reports_daily_sales },
      reports_sales_reports_monthly_sales: { on: selected_user.user_access.reports_sales_reports_monthly_sales },
      reports_sales_reports_yearly_sales: { on: selected_user.user_access.reports_sales_reports_yearly_sales },
      reports_sales_reports_receivables: { on: selected_user.user_access.reports_sales_reports_receivables },
      reports_inventory_reports: { ...element.reports_inventory_reports, on: selected_user.user_access.reports_inventory_reports },
      reports_inventory_reports_products_inventory: { on: selected_user.user_access.reports_inventory_reports_products_inventory },
      reports_inventory_reports_out_of_stocks: { on: selected_user.user_access.reports_inventory_reports_out_of_stocks },
      reports_inventory_reports_price_list: { on: selected_user.user_access.reports_inventory_reports_price_list },
      reports_inventory_reports_products_sold: { on: selected_user.user_access.reports_inventory_reports_products_sold },
      reports_inventory_reports_unmoving_products: { on: selected_user.user_access.reports_inventory_reports_unmoving_products },
      reports_inventory_reports_products_with_expirations: { on: selected_user.user_access.reports_inventory_reports_products_with_expirations },
      utilities: { ...element.utilities, on: selected_user.user_access.utilities },
      utilities_purchase_order: { on: selected_user.user_access.utilities_purchase_order },
      utilities_percent_off_batch_set: { on: selected_user.user_access.utilities_percent_off_batch_set },
      utilities_reset_percent_off: { on: selected_user.user_access.utilities_reset_percent_off },
      settings: { ...element.settings, on: selected_user.user_access.settings },
      settings_warehouses: { on: selected_user.user_access.settings_warehouses },
      settings_vat: { on: selected_user.user_access.settings_vat },
      settings_npos_accounts_settings: { on: selected_user.user_access.settings_npos_accounts_settings },
      help: { ...element.help, on: selected_user.user_access.help }
    })
    setUser(selected_user)
  }

  const onClickSave = async (e) => {
    const showSuccessMessageBox = () => {
      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          width='40'
          height='40'
          header='User Added Successfully'
          footer={null}>
            <div className='messagebox'>
              <div className='messagebox-content' style={{fontSize: '1.2rem'}}>
                <p>{`These changes will take effect only on the next login for those users who are currently online rightnow.`}</p>
                <br />
                <p>However, some changes will also take it's effect immediately for the user who executed the update.</p>
                <br />
              </div>
              <div className='button-container'>
                <button
                  onClick={() => { ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))}}
                  className='pospro-action-btn top-anchor'>
                  Ok
                </button>
              </div>
            </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    const showConfirmUpdateMessageBox = () => {
      const onClick = async (button) => {
        if (button === 'Yes') await proceedSaveClientUser()
        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }
      
      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          header='Confirm User Update/Changes'
          footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content' style={{fontSize: '1.2rem'}}>
              <p>{`Are you sure you want to make the changes?`}</p>
              <br />
            </div>
            <div className='button-container'>
              <button onClick={() => { onClick('No') }} className='pospro-action-btn top-anchor'>No</button>
              <button onClick={() => { onClick('Yes') }} className='pospro-action-btn bottom-anchor'>Yes</button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    const proceedSaveClientUser = async () => {
      // Validate and save
      if (changePassword) {
        user.login_details = {
          user_name: user.login_details.user_name,
          new_password: newUserPassword.password,
          confirm_new_password: newUserPassword.confirm_password
        }
      }

      const res = await updateClientUser('save')

      if (res.error) {
        setError(res.error)
      } else {
        setAddNew(false)
        setEdit(false)
        setChangePassword(false)
        setError(null)
        disableLeftWrapper()
        enableRightWrapper()

        // Reset element
        setElement(initElement)

        resetUser()
        setNewUserPassword({password: '', confirm_password: ''})
        clearTableRowFocus()

        showSuccessMessageBox()
      }
    }

    if (edit) showConfirmUpdateMessageBox()
    else await proceedSaveClientUser()
  }

  const onClickDelete = (e) => { showDeleteUserAccountMessageBox(user.id) }

  useEffect(() => {
    let login_details_error = {
      password: changePassword ? 'new_password' : 'password',
      confirm_password: changePassword ? 'confirm_new_password' : 'confirm_password'
    }
    if (error?.first_name) document.getElementById('first_name').focus()
    else if (error?.last_name) document.getElementById('last_name').focus()
    else if (error?.user_name) document.getElementById('user_name').focus()
    else if (error?.password) document.getElementById(login_details_error.password).focus()
    else if (error?.confirm_password) document.getElementById(login_details_error.confirm_password).focus()
  }, [error, changePassword])

  useEffect(() => {
    disableLeftWrapper()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ContentInner>
      <div className='users-accounts-settings-container'>
        {/*LEFT WRAPPER*/}
        <div className='left-wrapper'>
          {/******* User's Personal Information ****************/}
          <div className='control-wrapper'>
            <button
              id='users_personal_info'
              onClick={onClickWrapperHeader}
              className='control-header-title'>
              <FontAwesomeIcon icon={(element.users_personal_info.expand) ? 'caret-down' : 'caret-right'}/>&nbsp;
              User's Personal Information
            </button>
            <div className={(element.users_personal_info.expand) ? 'fields-container' : 'fields-container hide-fc'}>
              <input
                id='first_name'
                ref={firstNameRef}
                value={user.first_name}
                onChange={onChangeUserPersonalInfo}
                placeholder='First Name (required)'
                type='text'
              />
              <div className={(error?.first_name) ? 'error-notification' : 'hide-fc'}>
                <FontAwesomeIcon icon='exclamation-circle' />&nbsp;
                {error?.first_name ? error?.first_name[0] : null}
              </div>
              <input
                id='middle_name'
                value={user.middle_name}
                onChange={onChangeUserPersonalInfo}
                placeholder='Middle Name'
                type='text'
              />
              <input
                id='last_name'
                value={user.last_name}
                onChange={onChangeUserPersonalInfo}
                placeholder='Last Name (required)'
                type='text'
              />
              <div className={(error?.last_name) ? 'error-notification' : 'hide-fc'}>
                <FontAwesomeIcon icon='exclamation-circle' />&nbsp;
                {error?.last_name ? error?.last_name[0] : null}
              </div>
              <input
                id='designation'
                value={user.designation}
                onChange={onChangeUserPersonalInfo}
                placeholder='Designation'
                type='text'
              />
              <div className={(error?.is_full_name_exist) ? 'error-notification' : 'hide-fc'}>
                <FontAwesomeIcon icon='exclamation-circle' />&nbsp;
                {error?.is_full_name_exist ? error?.is_full_name_exist[0] : null}
              </div>
            </div>
          </div>

          {/******* Login Details ****************/}
          <div className='control-wrapper'>
            <button
              id='login_details'
              onClick={onClickWrapperHeader}
              className='control-header-title'>
              <FontAwesomeIcon icon={(element.login_details.expand) ? 'caret-down' : 'caret-right'}/>&nbsp;
              Login Details
            </button>
            <div className={(element.login_details.expand) ? 'fields-container' : 'fields-container hide-fc'}>
              <input
                id='user_name'
                value={user.login_details.user_name}
                onChange={onChangeUserLoginDetails}
                placeholder='Username (required)'
                type='text'
              />
              <div className={(error?.user_name) ? 'error-notification' : 'hide-fc'}>
                <FontAwesomeIcon icon='exclamation-circle' />&nbsp;
                {error?.user_name ? error?.user_name[0] : null}
              </div>
              <input
                id='password'
                value={user.login_details.password}
                onChange={onChangeUserLoginDetails}
                placeholder='Password (required)'
                type='password'
                style={{display: (addNew) ? 'block' : 'none'}}
              />
              <div className={(error?.password && !changePassword) ? 'error-notification' : 'hide-fc'}>
                <FontAwesomeIcon icon='exclamation-circle' />&nbsp;
                {error?.password ? error?.password[0] : null}
              </div>
              <input
                id='confirm_password'
                value={user.login_details.confirm_password || ''}
                onChange={onChangeUserLoginDetails}
                placeholder='Confirm Password (required)'
                type='password'
                style={{display: (addNew) ? 'block' : 'none'}}
              />
              <div className={(error?.confirm_password && !changePassword) ? 'error-notification' : 'hide-fc'}>
                <FontAwesomeIcon icon='exclamation-circle' />&nbsp;
                {error?.confirm_password ? error?.confirm_password[0] : null}
              </div>
              <input
                id='new_password'
                value={newUserPassword.password}
                onChange={(e) => { setNewUserPassword({...newUserPassword, password: e.target.value}) }}
                placeholder='New Password (required)'
                type='password'
                style={{display: (changePassword) ? 'block' : 'none'}}
              />
              <div className={(error?.password && changePassword) ? 'error-notification' : 'hide-fc'}>
                <FontAwesomeIcon icon='exclamation-circle' />&nbsp;
                {error?.password ? error?.password[0] : null}
              </div>
              <input
                id='confirm_new_password'
                value={newUserPassword.confirm_password}
                onChange={(e) => { setNewUserPassword({...newUserPassword, confirm_password: e.target.value}) }}
                placeholder='Confirm New Password (required)'
                type='password'
                style={{display: (changePassword) ? 'block' : 'none'}}
              />
              <div className={(error?.confirm_password && changePassword) ? 'error-notification' : 'hide-fc'}>
                <FontAwesomeIcon icon='exclamation-circle' />&nbsp;
                {error?.confirm_password ? error?.confirm_password[0] : null}
              </div>
              <div className='change-password-group-button'>
                <button
                  id='change-user-password'
                  className='change-user-password'
                  disabled={!edit}
                  onClick={onClickChangePassword}
                  style={{display: (addNew || changePassword) ? 'none' : 'block'}}>
                  Change Password
                </button>
              </div>
            </div>
          </div>

          {/******* Users Modules Access ****************/}
          <div className='control-wrapper'>
            <button
              id='users_modules_access'
              onClick={onClickWrapperHeader}
              className='control-header-title'>
              <FontAwesomeIcon icon={(element.users_modules_access.expand) ? 'caret-down' : 'caret-right'}/>&nbsp;
              User's Modules Access
            </button>
            <div className={(element.users_modules_access.expand) ? 'fields-container' : 'fields-container hide-fc'}>
              {/*DASHBOARD*/}
              {/*
              <div id='dashboard-cw' className='control-wrapper module'>
                <div
                  id='dashboard'
                  onClick={onClickWrapperHeader}
                  className='control-header-title'>
                  <div className='module-name'>
                    <FontAwesomeIcon icon={(element.dashboard.expand) ? 'caret-down' : 'caret-right'}/>&nbsp;
                    Dashboard
                  </div>
                  <SwitchButton setSwitch={setSwitch} id='dashboard' on={element.dashboard.on}/>
                </div>
              </div>
              */}
              <div id='dashboard-cw' className='control-wrapper module'>
                <DivButton
                  id='dashboard'
                  onClick={onClickWrapperHeader}
                  className='control-header-title'>
                  <div className='module-name'>
                    <FontAwesomeIcon icon={(element.dashboard.expand) ? 'caret-down' : 'caret-right'}/>&nbsp;
                    Dashboard
                  </div>
                  <SwitchButton setSwitch={setSwitch} id='dashboard' on={element.dashboard.on}/>
                </DivButton>
              </div>

              {/*PRODUCTS*/}
              <div id='products-cw' className='control-wrapper module'>
                <DivButton
                  id='products'
                  onClick={onClickWrapperHeader}
                  className='control-header-title'>
                  <div className='module-name'>
                    <FontAwesomeIcon icon={(element.products.expand) ? 'caret-down' : 'caret-right'}/>&nbsp;
                    Products
                  </div>
                  <SwitchButton setSwitch={setSwitch} id='products' on={element.products.on}/>
                </DivButton>
                <div className={(element.products.expand) ? 'fields-container' : 'fields-container hide-fc'}>
                  <DivButton className='modules-option'>
                    <div className='options-name'>Full Control</div>
                    <SwitchButton
                      small={true}
                      setSwitch={setSwitch}
                      id='products_fc'
                      on={element.products_fc.on}
                    />
                  </DivButton>
                </div>
              </div>

              {/*STOCKIN*/}
              <div id='stockin-cw' className='control-wrapper module'>
                <DivButton
                  id='stockin'
                  onClick={onClickWrapperHeader}
                  className='control-header-title'>
                  <div className='module-name'>
                    <FontAwesomeIcon icon={(element.stockin.expand) ? 'caret-down' : 'caret-right'}/>&nbsp;
                    Stockin
                  </div>
                  <SwitchButton setSwitch={setSwitch} id='stockin' on={element.stockin.on}/>
                </DivButton>
                <div className={(element.stockin.expand) ? 'fields-container' : 'fields-container hide-fc'}>
                  <DivButton className='modules-option'>
                    <div className='options-name'>Full Control</div>
                    <SwitchButton
                      small={true}
                      setSwitch={setSwitch}
                      id='stockin_fc'
                      on={element.stockin_fc.on}
                    />
                  </DivButton>
                </div>
              </div>

              {/*STOCKOUT*/}
              <div id='stockout-cw' className='control-wrapper module'>
                <DivButton
                  id='stockout'
                  onClick={onClickWrapperHeader}
                  className='control-header-title'>
                  <div className='module-name'>
                    <FontAwesomeIcon icon={(element.stockout.expand) ? 'caret-down' : 'caret-right'}/>&nbsp;
                    Stockout
                  </div>
                  <SwitchButton setSwitch={setSwitch} id='stockout' on={element.stockout.on}/>
                </DivButton>
                <div className={(element.stockout.expand) ? 'fields-container' : 'fields-container hide-fc'}>
                  <DivButton className='modules-option'>
                    <div className='options-name'>Full Control</div>
                    <SwitchButton
                      small={true}
                      setSwitch={setSwitch}
                      id='stockout_fc'
                      on={element.stockout_fc.on}
                    />
                  </DivButton>
                </div>
              </div>

              {/*INVOICE*/}
              <div id='invoice-cw' className='control-wrapper module'>
                <DivButton
                  id='invoice'
                  onClick={onClickWrapperHeader}
                  className='control-header-title'>
                  <div className='module-name'>
                    <FontAwesomeIcon icon={(element.invoice.expand) ? 'caret-down' : 'caret-right'}/>&nbsp;
                    Invoice
                  </div>
                  <SwitchButton setSwitch={setSwitch} id='invoice' on={element.invoice.on}/>
                </DivButton>
                <div className={(element.invoice.expand) ? 'fields-container' : 'fields-container hide-fc'}>
                  <DivButton className='modules-option'>
                    <div className='options-name'>Full Control</div>
                    <SwitchButton
                      small={true}
                      setSwitch={setSwitch}
                      id='invoice_fc'
                      on={element.invoice_fc.on}
                    />
                  </DivButton>
                </div>
              </div>

              {/*CUSTOMERS ACCOUNT*/}
              <div id='customers_accounts-cw' className='control-wrapper module'>
                <DivButton
                  id='customers_accounts'
                  onClick={onClickWrapperHeader}
                  className='control-header-title'>
                  <div className='module-name'>
                    <FontAwesomeIcon icon={(element.customers_accounts.expand) ? 'caret-down' : 'caret-right'}/>&nbsp;
                    Customer's Account
                  </div>
                  <SwitchButton setSwitch={setSwitch} id='customers_accounts' on={element.customers_accounts.on}/>
                </DivButton>
                <div className={(element.customers_accounts.expand) ? 'fields-container' : 'fields-container hide-fc'}>
                  <DivButton className='modules-option'>
                    <div className='options-name'>Full Control</div>
                    <SwitchButton
                      small={true}
                      setSwitch={setSwitch}
                      id='customers_accounts_fc'
                      on={element.customers_accounts_fc.on}
                    />
                  </DivButton> </div>
              </div>

              {/*RECEIPTS*/}
              <div id='receipts-cw' className='control-wrapper module'>
                <DivButton
                  id='receipts'
                  onClick={onClickWrapperHeader}
                  className='control-header-title'>
                  <div className='module-name'>
                    <FontAwesomeIcon icon={(element.receipts.expand) ? 'caret-down' : 'caret-right'}/>&nbsp;
                    Receipts
                  </div>
                  <SwitchButton setSwitch={setSwitch} id='receipts' on={element.receipts.on}/>
                </DivButton>
                <div className={(element.receipts.expand) ? 'fields-container' : 'fields-container hide-fc'}>
                  <DivButton className='modules-option'>
                    <div className='options-name'>Full Control</div>
                    <SwitchButton
                      small={true}
                      setSwitch={setSwitch}
                      id='receipts_fc'
                      on={element.receipts_fc.on}
                    />
                  </DivButton>
                </div>
              </div>

              {/*REPORTS*/}
              <div id='reports-cw' className='control-wrapper module'>
                <DivButton
                  id='reports'
                  onClick={onClickWrapperHeader}
                  className='control-header-title'>
                  <div className='module-name'>
                    <FontAwesomeIcon icon={(element.reports.expand) ? 'caret-down' : 'caret-right'}/>&nbsp;
                    Reports
                  </div>
                  <SwitchButton setSwitch={setSwitch} id='reports' on={element.reports.on}/>
                </DivButton>
                <div className={(element.reports.expand) ? 'fields-container' : 'fields-container hide-fc'}>

                  {/*SALES REPORTS*/}
                  <div id='reports_sales_reports-cw' className='control-wrapper module'>
                    <DivButton
                      id='reports_sales_reports'
                      onClick={onClickWrapperHeader}
                      className='control-header-title'>
                      <div className='module-name'>
                        <FontAwesomeIcon icon={(element.reports_sales_reports.expand) ? 'caret-down' : 'caret-right'}/>&nbsp;
                        Sales Reports
                      </div>
                      <SwitchButton
                        setSwitch={setSwitch}
                        id='reports_sales_reports'
                        on={element.reports_sales_reports.on}
                      />
                    </DivButton>
                    <div className={(element.reports_sales_reports.expand) ? 'fields-container' : 'fields-container hide-fc'}>
                      <DivButton className='modules-option'>
                        <div className='options-name'>Daily Sales</div>
                        <SwitchButton
                          small={true}
                          setSwitch={setSwitch}
                          id='reports_sales_reports_daily_sales'
                          on={element.reports_sales_reports_daily_sales.on}
                        />
                      </DivButton>
                      <DivButton className='modules-option'>
                        <div className='options-name'>Monthly Sales</div>
                        <SwitchButton
                          small={true}
                          setSwitch={setSwitch}
                          id='reports_sales_reports_monthly_sales'
                          on={element.reports_sales_reports_monthly_sales.on}
                        />
                      </DivButton>
                      <DivButton className='modules-option'>
                        <div className='options-name'>Yearly Sales</div>
                        <SwitchButton
                          small={true}
                          setSwitch={setSwitch}
                          id='reports_sales_reports_yearly_sales'
                          on={element.reports_sales_reports_yearly_sales.on}
                        />
                      </DivButton>
                      <DivButton className='modules-option'>
                        <div className='options-name'>Receivables</div>
                        <SwitchButton
                          small={true}
                          setSwitch={setSwitch}
                          id='reports_sales_reports_receivables'
                          on={element.reports_sales_reports_receivables.on}
                        />
                      </DivButton>
                    </div>
                  </div>

                  {/*INVENTORY REPORTS*/}
                  <div id='reports_inventory_reports-cw' className='control-wrapper module'>
                    <DivButton
                      id='reports_inventory_reports'
                      onClick={onClickWrapperHeader}
                      className='control-header-title'>
                      <div className='module-name'>
                        <FontAwesomeIcon icon={(element.reports_inventory_reports.expand) ? 'caret-down' : 'caret-right'}/>&nbsp;
                        Inventory Reports
                      </div>
                      <SwitchButton setSwitch={setSwitch} id='reports_inventory_reports' on={element.reports_inventory_reports.on}/>
                    </DivButton>
                    <div className={(element.reports_inventory_reports.expand) ? 'fields-container' : 'fields-container hide-fc'}>
                      <DivButton className='modules-option'>
                        <div className='options-name'>Products Inventory</div>
                        <SwitchButton
                          small={true}
                          setSwitch={setSwitch}
                          id='reports_inventory_reports_products_inventory'
                          on={element.reports_inventory_reports_products_inventory.on}
                        />
                      </DivButton>
                      <DivButton className='modules-option'>
                        <div className='options-name'>Out Of Stocks</div>
                        <SwitchButton
                          small={true}
                          setSwitch={setSwitch}
                          id='reports_inventory_reports_out_of_stocks'
                          on={element.reports_inventory_reports_out_of_stocks.on}
                        />
                      </DivButton>
                      <DivButton className='modules-option'>
                        <div className='options-name'>Price List</div>
                        <SwitchButton
                          small={true}
                          setSwitch={setSwitch}
                          id='reports_inventory_reports_price_list'
                          on={element.reports_inventory_reports_price_list.on}
                        />
                      </DivButton>
                      <DivButton className='modules-option'>
                        <div className='options-name'>Products Sold</div>
                        <SwitchButton
                          small={true}
                          setSwitch={setSwitch}
                          id='reports_inventory_reports_products_sold'
                          on={element.reports_inventory_reports_products_sold.on}
                        />
                      </DivButton>
                      <DivButton className='modules-option'>
                        <div className='options-name'>Unmoving Products</div>
                        <SwitchButton
                          small={true}
                          setSwitch={setSwitch}
                          id='reports_inventory_reports_unmoving_products'
                          on={element.reports_inventory_reports_unmoving_products.on}
                        />
                      </DivButton>
                      <DivButton className='modules-option'>
                        <div className='options-name'>Products With Expirations</div>
                        <SwitchButton
                          small={true}
                          setSwitch={setSwitch}
                          id='reports_inventory_reports_products_with_expirations'
                          on={element.reports_inventory_reports_products_with_expirations.on}
                        />
                      </DivButton>
                    </div>
                  </div>
                </div>
              </div>

              {/*UTILITIES*/}
              <div id='utilities-cw' className='control-wrapper module'>
                <DivButton
                  id='utilities'
                  onClick={onClickWrapperHeader}
                  className='control-header-title'>
                  <div className='module-name'>
                    <FontAwesomeIcon icon={(element.utilities.expand) ? 'caret-down' : 'caret-right'}/>&nbsp;
                    Utilities
                  </div>
                  <SwitchButton setSwitch={setSwitch} id='utilities' on={element.utilities.on}/>
                </DivButton>
                <div className={(element.utilities.expand) ? 'fields-container' : 'fields-container hide-fc'}>
                  <DivButton className='modules-option'>
                    <div className='options-name'>Purchase Order</div>
                    <SwitchButton
                      small={true}
                      setSwitch={setSwitch}
                      id='utilities_purchase_order'
                      on={element.utilities_purchase_order.on}
                    />
                  </DivButton>
                  <DivButton className='modules-option'>
                    <div className='options-name'>Percent Off Batch Set</div>
                    <SwitchButton
                      small={true}
                      setSwitch={setSwitch}
                      id='utilities_percent_off_batch_set'
                      on={element.utilities_percent_off_batch_set.on}
                    />
                  </DivButton>
                  <DivButton className='modules-option'>
                    <div className='options-name'>Reset Percent Off</div>
                    <SwitchButton
                      small={true}
                      setSwitch={setSwitch}
                      id='utilities_reset_percent_off'
                      on={element.utilities_reset_percent_off.on}
                    />
                  </DivButton>
                </div>
              </div>

              {/*SETTINGS*/}
              <div id='settings-cw' className='control-wrapper module'>
                <DivButton
                  id='settings'
                  onClick={onClickWrapperHeader}
                  className='control-header-title'>
                  <div className='module-name'>
                    <FontAwesomeIcon icon={(element.settings.expand) ? 'caret-down' : 'caret-right'}/>&nbsp;
                    Settings
                  </div>
                  <SwitchButton setSwitch={setSwitch} id='settings' on={element.settings.on}/>
                </DivButton>
                <div className={(element.settings.expand) ? 'fields-container' : 'fields-container hide-fc'}>
                  <DivButton className='modules-option'>
                    <div className='options-name'>Warehouses</div>
                    <SwitchButton
                      small={true}
                      setSwitch={setSwitch}
                      id='settings_warehouses'
                      on={element.settings_warehouses.on}
                    />
                  </DivButton>
                  <DivButton className='modules-option'>
                    <div className='options-name'>VAT</div>
                    <SwitchButton
                      small={true}
                      setSwitch={setSwitch}
                      id='settings_vat'
                      on={element.settings_vat.on}
                    />
                  </DivButton>
                  <DivButton className='modules-option'>
                    <div className='options-name'>NPOS Accounts Settings</div>
                    <SwitchButton
                      small={true}
                      setSwitch={setSwitch}
                      id='settings_npos_accounts_settings'
                      on={element.settings_npos_accounts_settings.on}
                    />
                  </DivButton>
                </div>
              </div>

              {/*HELP*/}
              <div id='help-cw' className='control-wrapper module last'>
                <DivButton
                  id='help'
                  onClick={onClickWrapperHeader}
                  className='control-header-title'>
                  <div className='module-name'>
                    <FontAwesomeIcon icon={(element.help.expand) ? 'caret-down' : 'caret-right'}/>&nbsp;
                    Help
                  </div>
                  <SwitchButton setSwitch={setSwitch} id='help' on={element.help.on}/>
                </DivButton>
              </div>

            </div>
          </div>

          {/*ADD BUTTON*/}
          <hr />
          <div className='action-button-container'>
            <div className={(addNew || edit) ? 'hide-fc' : 'aed-button-group'}>
              <button
                id='add-new-btn'
                onClick={onClickAddNew}
                className='pospro-action-btn'>
                <FontAwesomeIcon icon='save'/>&nbsp;
                Add New
              </button>
              <button
                id='edit-btn'
                onClick={onClickEdit}
                disabled={!user.id}
                className={(user.id) ? 'pospro-action-btn' : 'pospro-action-btn disabled-button'}>
                <FontAwesomeIcon icon='edit'/>&nbsp;
                Edit
              </button>
              <button
                id='delete-btn'
                onClick={onClickDelete}
                disabled={!user.id}
                className={(user.id) ? 'pospro-action-btn' : 'pospro-action-btn disabled-button'}>
                <FontAwesomeIcon icon='times'/>&nbsp;
                Delete
              </button>
            </div>
            <div className={(addNew || edit) ? 'cs-button-group' : 'hide-fc'}>
              <button
                id='cancel-btn'
                onClick={onClickCancel}
                className='pospro-action-btn'>
                <FontAwesomeIcon icon='undo'/>&nbsp;
                Cancel
              </button>
              <button
                id='save-btn'
                onClick={onClickSave}
                className='pospro-action-btn'>
                <FontAwesomeIcon icon='save'/>&nbsp;
                Save
              </button>
            </div>
          </div>
        </div>

        {/*RIGHT WRAPPER*/}
        <div className='right-wrapper'>
          <div className='control-wrapper'>
            {/*<div className='control-header-title'> <div className='module-name'>User's List</div> </div>*/}
            <div className='control-header-title'>User's List</div>
            <table className='table stripe-table'>
              <thead>
                <tr>
                  <th className='empty-header'>#</th>
                  <th className='empty-header'>ID</th>
                  <th className='empty-header'>First Name</th>
                  <th className='empty-header'>Middle Name</th>
                  <th className='empty-header'>Last Name</th>
                  <th className='empty-header'>Designation</th>
                  <th style={{textAlign: 'center'}} className='empty-header'>Action</th>
                </tr>
              </thead>
              <tbody>
              {
                users.map((user, index) => (
                  <tr key={user.id} className='user-row' onClick={onClickUser} id={user.id}>
                    <td>{index + 1}</td>
                    <td>{user.id}</td>
                    <td>{user.first_name}</td>
                    <td>{user.middle_name}</td>
                    <td>{user.last_name}</td>
                    <td>{user.designation}</td>
                    <td style={{textAlign: 'center'}}>
                      <CloseButton onClick={onClickDeleteUserAccount} title='delete user'/>
                    </td>
                  </tr>
                ))
              }
              </tbody>
            </table>
          </div>
        </div>

      </div>
      <UsersAccountsStyle />
    </ContentInner>
  )
}

export default React.memo(UsersAccounts)